import { useLingui } from "@lingui/react/macro";
import { multipleLabel, type BatchScale } from "@/lib/recipes/staged-method";

/** "Half", "Full", "5x": the batch a card's quantities are for. */
export function useBatchSizeLabel() {
  const { t } = useLingui();
  return (scale: BatchScale) => (scale === 0.5 ? t`Half` : scale === 1 ? t`Full` : multipleLabel(scale));
}
